import { homeConstants } from "../constants";

export default function (
  state = {
    error: "",
    isProgress: false,
    data: [],
  },
  action
) {
  switch (action.type) {
    case homeConstants.TOP_TEN_PRODUCTS_REQUEST:
      return {
        ...state,
        isProgress: true,
      };
    case homeConstants.TOP_TEN_PRODUCTS_SUCCESS: {
      let result = [];
      if (action.response && action.response.data) {
        result = action.response.data.map((item) => {
          return {
            ...item,
            productId: item.id,
          };
        });
      }
      return {
        ...state,
        data: result,
        isProgress: false,
      };
    }
    case homeConstants.TOP_TEN_PRODUCTS_ERROR:
      return {
        ...state,
        error: action.error,
        data: [],
        isProgress: false,
      };
    default:
      return state;
  }
}
